import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { signIn, signInWithGoogle } from "../../Redux/Auth/authActions";

import "../../Stylesheets/Auth/SignIn.css"; // ✅ shared file for both SignIn + SignUp
import Navbar from "../../Components/Common/Navbar";
import NewsletterSection from "../../Components/Home/FooterWithNewsletter";
import PageWrapper from "../../Components/Common/PageWrapper";
import AlertBox from "../../Components/Common/AlertBox";

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);

  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });

  const [localAlert, setLocalAlert] = useState({ type: "error", message: "" });
  const setAlert = (message, type = "error") => setLocalAlert({ type, message });
  const clearAlert = () => setLocalAlert({ type: "error", message: "" });

  const handleChange = (e) => {
    if (localAlert.message) clearAlert();
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      setAlert("Email and password are required");
      return;
    }
    clearAlert();
    dispatch(signIn(formData.email, formData.password, navigate, keepSignedIn));
  };

  const handleGoogleSignIn = () => {
    clearAlert();
    dispatch(signInWithGoogle(navigate, keepSignedIn));
  };

  useEffect(() => {
    if (error) setAlert(error, "error");
  }, [error]);

  return (
    <>
      <Navbar />

      {/* ✅ background wrapper (replace bubble background) */}
      <div className="auth-page-bg">
        <PageWrapper>
          <div className="auth-wrap">
            <div className="auth-card">
              <div className="auth-head">
                <h2 className="auth-title">Sign in</h2>
                <p className="auth-subtitle">
                  Welcome back — access your projects in seconds.
                </p>
              </div>

              <AlertBox type={localAlert.type} message={localAlert.message} onClose={clearAlert} />

              <button className="auth-google" onClick={handleGoogleSignIn} type="button">
                <FcGoogle size={20} />
                <span>Sign in with Google</span>
              </button>

              <div className="auth-divider">
                <span>Or, sign in with your email</span>
              </div>

              <form className="auth-form" onSubmit={handleSubmit}>
                <div className="auth-field">
                  <label className="auth-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    className="auth-input"
                    value={formData.email}
                    onChange={handleChange}
                    autoComplete="email"
                  />
                </div>

                <div className="auth-field">
                  <label className="auth-label">Password</label>
                  <input
                    type="password"
                    name="password"
                    placeholder="Enter your password"
                    className="auth-input"
                    value={formData.password}
                    onChange={handleChange}
                    autoComplete="current-password"
                  />
                </div>

                <div className="auth-row">
                  <label className="auth-check">
                    <input
                      type="checkbox"
                      checked={keepSignedIn}
                      onChange={(e) => setKeepSignedIn(e.target.checked)}
                    />
                    <span>Keep me signed in</span>
                  </label>

                  <Link to="/forgot-password" className="auth-link">
                    Forgot password?
                  </Link>
                </div>

                <button type="submit" className="auth-submit" disabled={loading}>
                  {loading ? "Signing in..." : "Sign In"}
                </button>
              </form>

              <p className="auth-foot">
                Don’t have an account? <Link to="/signup">Create one</Link>
              </p>
            </div>
          </div>
        </PageWrapper>
      </div>

      <NewsletterSection />
    </>
  );
};

export default SignIn;
